export const RESET = 'containers/Search/RESET';
export const CHANGE_INPUT = 'containers/Search/CHANGE_INPUT';
